<template>
    <div class="page">
      <Header/>
      <MatchInfo />
      <AthleticsHome />
      <Footer/>
    </div>
  </template>
  
<script>
import AthleticsHome from '@comm/components/match/trackfield/TrackFieldHome';
import MatchInfo from '@comm/components/MatchInfo.vue'
import Header from '@district/components/common/MatchHeader.vue'
import Footer from '@district/components/common/Footer'
export default {
  name: 'TrackField',
  components: {
    Header,
    Footer,
    MatchInfo,
    AthleticsHome
  },
  data () {
    return {
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {
  },
  methods: {
  }
}
</script>
  <style lang="scss" scoped>
  .page {
    width: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/district/views/project/components/TrackField.vue